export default "__VITE_ASSET__Dmp9x9nA__"